import { render, staticRenderFns } from "./AdvHome.vue?vue&type=template&id=01b54bf9&scoped=true&"
import script from "./AdvHome.vue?vue&type=script&lang=js&"
export * from "./AdvHome.vue?vue&type=script&lang=js&"
import style0 from "./AdvHome.vue?vue&type=style&index=0&id=01b54bf9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b54bf9",
  null
  
)

export default component.exports